import getStore from 'services/getStore';
import { getTopicGroupFromState, getTopicsFromGroup } from 'selectors/block';

// export default () => {
//   const state = getStore().getState();
//   return getTopicsFromGroup(state, getTopicGroupFromState(state));
// };

export default () => {
  const store = getStore && getStore();

  if (store) {
    const state = store.getState();
    if (state) {
      return getTopicsFromGroup(state, getTopicGroupFromState(state));
    }
  }

  return [];
};
